import { render, staticRenderFns } from "./AdminUpdate.vue?vue&type=template&id=1c828b91&"
import script from "./AdminUpdate.vue?vue&type=script&lang=ts&"
export * from "./AdminUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports